import { render, staticRenderFns } from "./UserAccountsView.vue?vue&type=template&id=050c9e46&scoped=true&"
import script from "./UserAccountsView.vue?vue&type=script&lang=ts&"
export * from "./UserAccountsView.vue?vue&type=script&lang=ts&"
import style0 from "./UserAccountsView.vue?vue&type=style&index=0&id=050c9e46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "050c9e46",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('050c9e46')) {
      api.createRecord('050c9e46', component.options)
    } else {
      api.reload('050c9e46', component.options)
    }
    module.hot.accept("./UserAccountsView.vue?vue&type=template&id=050c9e46&scoped=true&", function () {
      api.rerender('050c9e46', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "landing/src/views/admin/accounts/UserAccountsView.vue"
export default component.exports